// Konfigurator haftu (Stickerei) na karcie produktu Favre - snippets/favre-stickerei.liquid, 2026-10-27.
// Port z dobrelegowiska (assets/custom-haft.js), dopasowany do własnej galerii favre-product.js:
// - włączenie = wybrana wartość opcji haftu (Ja / Mit / Yes / Tak) albo makieta z ?stickerei-demo=1,
// - po włączeniu galeria przechodzi na zdjęcie frontalne i TYLKO tam rysujemy napis,
// - pola bez `name`, gdy haft wyłączony (dynamic checkout ignoruje `disabled`),
// - blokada „In den Warenkorb” i przycisków szybkiej płatności, gdy haft wybrany, a imienia brak.
(() => {
  const params = new URLSearchParams(location.search);
  const DEMO = params.has('stickerei-demo');
  const KALIB = params.has('stickerei-kalibrierung');
  const HELL = ['#f7f7f7', '#c9a227'];

  // wartości przenoszone między kolorami (zmiana koloru podmienia cały panel)
  const pamiec = { name: '', schrift: 'schreib', farbe: null, demoAn: false };

  let st = null; // stan bieżącej karty

  const czyAn = (w) => /^(ja|mit|yes|tak)\b/i.test(String(w || '').trim());

  function wlaczony() {
    if (!st) return false;
    if (st.demo) return DEMO && pamiec.demoAn;
    const row = st.root.querySelector(`[data-fp-option="${st.idx}"]`);
    return czyAn(row?.querySelector('.fp__pill.is-active')?.dataset.value);
  }

  function pola() {
    return [...st.box.querySelectorAll('[name^="properties["], [data-fst-name]')];
  }

  function ustawPola(an) {
    if (st.demo) {
      pola().forEach((p) => { p.disabled = !an; });
      return;
    }
    pola().forEach((p) => {
      if (an) {
        const n = p.getAttribute('data-fst-name');
        if (n) { p.setAttribute('name', n); p.removeAttribute('data-fst-name'); }
        p.disabled = false;
      } else {
        const n = p.getAttribute('name');
        if (n) { p.setAttribute('data-fst-name', n); p.removeAttribute('name'); }
        p.disabled = true;
      }
    });
  }

  /* ---------- podgląd na zdjęciu frontalnym ---------- */

  function slajdFront() {
    if (!st.mediaId) return null;
    return st.root.querySelector(`.fp__slide[data-media-id="${st.mediaId}"]`);
  }

  function indeksFront() {
    const s = [...st.root.querySelectorAll('[data-fp-track] .fp__slide')];
    return s.findIndex((x) => x.dataset.mediaId === st.mediaId);
  }

  function idzDoFrontu() {
    const i = indeksFront();
    if (i < 0) return;
    if (typeof st.root.fpGoTo === 'function') st.root.fpGoTo(i);
    else st.root.querySelector(`[data-fp-goto="${i}"]`)?.click();
  }

  function podglad() {
    const slide = slajdFront();
    if (!slide) return null;
    let el = slide.querySelector('.fst-vorschau');
    if (!el) {
      el = document.createElement('span');
      el.className = 'fst-vorschau';
      el.setAttribute('aria-hidden', 'true');
      slide.style.position = 'relative';
      slide.appendChild(el);
      const img = slide.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', ustawPozycje, { once: true });
      if ('ResizeObserver' in window) new ResizeObserver(ustawPozycje).observe(slide);
      if (KALIB) kalibracja(el);
    }
    return el;
  }

  function ustawPozycje() {
    if (!st) return;
    const slide = slajdFront();
    const el = slide?.querySelector('.fst-vorschau');
    const img = slide?.querySelector('img');
    if (!el || !img) return;
    const [lewo, gora, obrot, rozmiar] = st.pos;
    // procenty liczone od PROSTOKĄTA ZDJĘCIA (slajd ma padding i object-fit), offsetLeft/Top bez transformacji przenikania
    const w = img.offsetWidth;
    const h = img.offsetHeight;
    if (!w || !h) return;
    el.style.left = `${Math.round(img.offsetLeft + (w * lewo) / 100)}px`;
    el.style.top = `${Math.round(img.offsetTop + (h * gora) / 100)}px`;
    el.style.fontSize = `${Math.max(8, Math.round((h * rozmiar) / 100))}px`;
    el.style.transform = `translate(-50%, -50%) rotate(${obrot}deg)`;
  }

  function odswiez() {
    if (!st) return;
    const an = wlaczony();
    st.box.hidden = st.demo ? !DEMO : !an;
    st.body.hidden = !an;
    const el = podglad();
    if (!el) return;
    const tekst = st.input.value.trim();
    const schrift = st.box.querySelector('[data-fst-schrift]:checked')?.dataset.fstSchrift || 'schreib';
    const farbe = st.box.querySelector('[data-fst-farbe]:checked');
    const kolor = farbe?.dataset.fstFarbe || '#111111';
    el.hidden = !an;
    el.textContent = tekst || 'Name';
    el.classList.toggle('fst-vorschau--leer', !tekst);
    el.classList.toggle('fst-vorschau--schreib', schrift === 'schreib');
    el.classList.toggle('fst-vorschau--druck', schrift === 'druck');
    el.classList.toggle('fst-vorschau--hell', HELL.includes(kolor));
    el.style.setProperty('--nic', kolor);
    ustawPozycje();
  }

  function zmianaStanu() {
    const an = wlaczony();
    ustawPola(an);
    if (an && !st.bylAn) idzDoFrontu();
    st.bylAn = an;
    if (!an) st.input.classList.remove('is-fehler'), (st.warn.hidden = true);
    odswiez();
  }

  /* ---------- blokada zakupu bez imienia ---------- */

  function brakImienia() {
    return st && wlaczony() && !st.demo && !st.input.value.trim();
  }

  function pokazBlad(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    st.warn.hidden = false;
    st.input.classList.add('is-fehler');
    idzDoFrontu();
    st.input.focus({ preventScroll: true });
    st.input.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  document.addEventListener('submit', (e) => {
    // getAttribute, bo form.id zwraca <input name="id"> (pole wariantu), a nie atrybut id formularza
    if (!st || e.target.getAttribute?.('id') !== st.formId) return;
    if (brakImienia()) pokazBlad(e);
  }, true);

  document.addEventListener('click', (e) => {
    if (!st) return;
    const t = e.target.closest?.('.shopify-payment-button, shopify-buy-it-now-button, shopify-accelerated-checkout, [data-shopify="payment-button"]');
    if (!t || !st.root.contains(t)) return;
    if (brakImienia()) pokazBlad(e);
  }, true);

  /* ---------- start / ponowny start po zmianie koloru ---------- */

  function start() {
    const root = document.querySelector('[data-fp]');
    const box = root?.querySelector('[data-fst]');
    if (!box) { st = null; return; }
    if (box.dataset.fstGotowe) { odswiez(); return; } // ten sam panel - już podpięty (favre:init po DOMContentLoaded)
    box.dataset.fstGotowe = '1';
    const pos = (box.dataset.fstPos || '50,60,0,5.5').split(',').map(Number);
    st = {
      root,
      box,
      body: box.querySelector('[data-fst-body]'),
      input: box.querySelector('[data-fst-input]'),
      warn: box.querySelector('[data-fst-warnung]'),
      zaehler: box.querySelector('[data-fst-zaehler]'),
      demo: box.hasAttribute('data-fst-demo'),
      idx: Number(box.dataset.fstIdx),
      mediaId: box.dataset.fstMedia || null,
      handle: box.dataset.fstHandle || '',
      formId: box.querySelector('[data-fst-input]')?.getAttribute('form') || '',
      pos: pos.length === 4 && pos.every((x) => !Number.isNaN(x)) ? pos : [50, 60, 0, 5.5],
      bylAn: false,
    };

    // przywrócenie wpisanych wartości (zmiana koloru)
    st.input.value = pamiec.name;
    st.zaehler.textContent = `${pamiec.name.length}/10`;
    const s = box.querySelector(`[data-fst-schrift="${pamiec.schrift}"]`);
    if (s) s.checked = true;
    if (pamiec.farbe) {
      const f = box.querySelector(`[data-fst-farbe="${pamiec.farbe}"]`);
      if (f) f.checked = true;
    }
    const nazwaF = box.querySelector('[data-fst-farbe]:checked')?.value;
    const fn = box.querySelector('[data-fst-farbname]');
    if (fn && nazwaF) fn.textContent = nazwaF;

    st.input.addEventListener('input', () => {
      // tylko litery (z umlautami i akcentami), spacja, apostrof, myślnik - maks. 10 znaków
      const czysty = st.input.value.replace(/[^\p{L} '\-]/gu, '').replace(/\s{2,}/g, ' ').slice(0, 10);
      if (czysty !== st.input.value) st.input.value = czysty;
      pamiec.name = czysty;
      st.zaehler.textContent = `${czysty.length}/10`;
      if (czysty.trim()) { st.warn.hidden = true; st.input.classList.remove('is-fehler'); }
      odswiez();
    });
    st.input.addEventListener('focus', idzDoFrontu);
    box.addEventListener('change', (e) => {
      // radio bez `name` (haft wyłączony / makieta) nie tworzą grupy - pilnujemy jednego zaznaczenia sami
      ['[data-fst-schrift]', '[data-fst-farbe]'].forEach((sel) => {
        if (e.target.matches(sel)) box.querySelectorAll(sel).forEach((r) => { if (r !== e.target) r.checked = false; });
      });
      if (e.target.matches('[data-fst-schrift]')) { pamiec.schrift = e.target.dataset.fstSchrift; idzDoFrontu(); }
      if (e.target.matches('[data-fst-farbe]')) {
        pamiec.farbe = e.target.dataset.fstFarbe;
        if (fn) fn.textContent = e.target.value;
        idzDoFrontu();
      }
      odswiez();
    });

    if (st.demo) {
      const pille = [...box.querySelectorAll('[data-fst-demo-wert]')];
      const zaznacz = () => pille.forEach((p) => {
        const on = (p.dataset.fstDemoWert === 'ja') === pamiec.demoAn;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      pille.forEach((p) => p.addEventListener('click', () => {
        pamiec.demoAn = p.dataset.fstDemoWert === 'ja';
        zaznacz();
        zmianaStanu();
      }));
      zaznacz();
    }

    st.bylAn = wlaczony();
    ustawPola(st.bylAn);
    odswiez();
    if (st.bylAn && (st.input.value || KALIB)) idzDoFrontu();
  }

  document.addEventListener('favre:variant', () => { if (st) zmianaStanu(); });
  document.addEventListener('favre:init', start);
  window.addEventListener('resize', ustawPozycje, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* ---------- kalibracja pozycji (?stickerei-kalibrierung=1) ---------- */

  function kalibracja(el) {
    el.classList.add('is-kalib');
    let pas = document.querySelector('.fst-kalib');
    if (!pas) {
      pas = document.createElement('div');
      pas.className = 'fst-kalib';
      pas.innerHTML = 'Stickerei Position: <span data-k></span><button type="button" data-kopie>Kopieren</button><button type="button" data-zapisz>Speichern im Admin</button><span data-info></span>';
      document.body.appendChild(pas);
      pas.querySelector('[data-kopie]').addEventListener('click', () => navigator.clipboard?.writeText(pas.querySelector('[data-k]').textContent));
      // Zapis: strona sklepu nie może pisać do produktu (wymaga klucza admina), więc kopiujemy liczby
      // i otwieramy produkt w panelu Shopify - tam pole „Stickerei Position” w sekcji Metapola, wklej + Zapisz.
      pas.querySelector('[data-zapisz]').addEventListener('click', async () => {
        const wart = pas.querySelector('[data-k]').textContent;
        try { await navigator.clipboard.writeText(wart); } catch (e) {}
        const sklep = (window.Shopify?.shop || '').replace('.myshopify.com', '');
        window.open(`https://admin.shopify.com/store/${sklep}/products/${st.box.dataset.fstProduct}`, '_blank', 'noopener');
        pas.querySelector('[data-info]').textContent = ` - ${wart} kopiert. Im Admin: Metafelder > Stickerei Position > Strg+V > Speichern.`;
      });
    }
    const pokaz = () => {
      const p = st.pos.map((x) => Math.round(x * 10) / 10).join(',');
      // same liczby - wklejane w panelu Shopify: produkt > Metapola > „Stickerei Position” (favre.stickerei_pos)
      pas.querySelector('[data-k]').textContent = p;
    };
    pokaz();
    el.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      el.setPointerCapture(e.pointerId);
      const img = el.parentElement.querySelector('img');
      const ruch = (ev) => {
        const r = img.getBoundingClientRect();
        st.pos[0] = Math.min(100, Math.max(0, ((ev.clientX - r.left) / r.width) * 100));
        st.pos[1] = Math.min(100, Math.max(0, ((ev.clientY - r.top) / r.height) * 100));
        ustawPozycje();
        pokaz();
      };
      const koniec = () => { el.removeEventListener('pointermove', ruch); el.removeEventListener('pointerup', koniec); };
      el.addEventListener('pointermove', ruch);
      el.addEventListener('pointerup', koniec);
    });
    el.addEventListener('wheel', (e) => {
      e.preventDefault();
      const d = e.deltaY < 0 ? 1 : -1;
      if (e.shiftKey) st.pos[2] = Math.round((st.pos[2] + d * 0.5) * 10) / 10;
      else st.pos[3] = Math.max(1, Math.round((st.pos[3] + d * 0.1) * 10) / 10);
      ustawPozycje();
      pokaz();
    }, { passive: false });
  }
})();
